import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { EventLog } from '../components/EventLog';
import { ReportStatus } from '../components/ReportStatus';
import { RouteGuard } from '../components/RouteGuard';
import { appRoles } from '../util/authUtil';
import { CompanySelect } from '../components/CompanySelect';
import { IPomReportDataInfo, IUserCompanies } from '../util/DataModelInterface';
import { useEffect, useState } from 'react';
import * as reportApi from '../api/PomReport';
import { reportListView } from '../components/CommonControls';
import { FormattedMessage } from 'react-intl';
import useToastHandler from '../hooks/useToastHandler';
import { Spinner } from '../components/Spinner';

interface IHomeProps {
  userLoaded?: boolean;
}

export const Home = (props: IHomeProps) => {
  const { addToast } = useToastHandler();

  const [selectedCompany, setSelectedCompany] = useState({} as IUserCompanies);
  const [reports, setReports] = useState([] as IPomReportDataInfo[]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (selectedCompany.id) {
      setLoading(true);
      let id = parseInt(selectedCompany.id);
      reportApi.getReportStatus([id]).then((data: any) => {
          if (data?.error) {
            addToast(data.error, 'reports', 'fetch');
          } else if (data) {
            setReports(data);
          }
      }).finally(() => {
        setLoading(false);
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCompany]);

  if (!props.userLoaded) {
    return null;
  }
  
  return (
    <>
      <AuthenticatedTemplate>
        <RouteGuard  roles={[appRoles.Admin]}>
          <EventLog/>
        </RouteGuard>
        <RouteGuard  roles={[appRoles.GuestReporter]}>
          <Spinner active={loading} />
          <CompanySelect onCompSelect={(c: IUserCompanies) => setSelectedCompany(c)} />
          <ReportStatus selectedCompany={selectedCompany} />
          <h3><FormattedMessage id="reports.allreports"/> {selectedCompany.name ? " - " + selectedCompany.name : ""}</h3>
          {reportListView( selectedCompany.name, reports )}
        </RouteGuard>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
      </UnauthenticatedTemplate>
    </>
  );
};